import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  Pagination,
  BranchService, BranchContainerModel, ApiVisa
} from 'blg-akaun-ts-lib';
import { forkJoin, iif, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, tap, filter, switchMap, distinctUntilChanged, map, mergeMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'blg-select-branch-drop-down',
  templateUrl: './select-branch-drop-down.component.html',
  styleUrls: ['./select-branch-drop-down.component.scss']
})

export class SelectBranchDropDownComponent implements OnInit, OnDestroy {

  @Input() apiVisa: ApiVisa;
  @Input() branch = new FormControl();
  @Input() required: boolean;
  @Input() companySelectedGuid: string;

  @Output() branchChange = new EventEmitter<FormControl>();
  @Output() branchSelected = new EventEmitter<BranchContainerModel>();

  serverSideFiltering = new FormControl();
  currentBranch = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<BranchContainerModel[]> = new ReplaySubject<BranchContainerModel[]>(1);
  branchList: BranchContainerModel[] = [];
  selectedBranch: BranchContainerModel;
  temporaryBranch: any = [];
  filteredBranch: any = [];

  protected _onDestroy = new Subject<void>();

  constructor(
    private branchService: BranchService,
  ) {
  }

  ngOnInit() {
    // if (this.branch.value) {
    //   this.branchService.getByGuid(this.branch.value, this.apiVisa).pipe(
    //     takeUntil(this._onDestroy)
    //   ).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     // this.filteredOptions$.next([resolved.data]);
    //     this.filteredBranch.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    // if (this.branch.value) {
    //   this.branchService.getByGuid(this.branch.value, this.apiVisa).pipe(
    //     takeUntil(this._onDestroy)
    //   ).subscribe( resolved => {
    //     // this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBranch();
      });

    this.getBranch();
    // this.serverSideFiltering.valueChanges.pipe(
    //     filter(searchText => searchText.length > 3),
    //     tap(() => this.serverSideSearching = true),
    //     debounceTime(300),
    //     distinctUntilChanged(),
    //     switchMap(searchText => this.searchBranch(searchText))
    //   ).subscribe( resolved => {
    //     this.serverSideSearching = false;
    //     if (this.selectedBranch) {
    //       this.filteredOptions$.next([...resolved, this.selectedBranch]);
    //       this.branchList = [...resolved, this.selectedBranch];
    //     } else {
    //       this.filteredOptions$.next(resolved);
    //       this.branchList = resolved;
    //     }
    //   }, error => {
    //     this.serverSideSearching = false;
    //     console.error(error);
    //   });
  }

   ngOnChanges() {
    if (this.companySelectedGuid) {
      this.getBranch();
    }
  }

  getBranch() {
    // Clear arrays to avoid duplicates
    this.filteredBranch = [];
    this.branchList = [];
    if (this.companySelectedGuid) {
      let pagination = new Pagination();
      pagination.conditionalCriteria = [];
      pagination.conditionalCriteria.push({ columnName: 'comp_guid', operator: '=', value: this.companySelectedGuid });
      this.branchService.getByCriteria(pagination, this.apiVisa).subscribe((x: any) => {
        x.data.forEach((data) => {
          this.filteredBranch.push(data);
          this.branchList.push(data);
        });
        // sorting
        const sorted = this.filteredBranch.sort((a, b) => (a.bl_fi_mst_branch.code < b.bl_fi_mst_branch.code ? -1 : 1));
        this.filteredBranch = sorted;
        this.filteredOptions$.next(this.filteredBranch.slice());
      });
    } else {
      this.branchService.get(this.apiVisa).subscribe((x: any) => {
        x.data.forEach((data) => {
          this.filteredBranch.push(data);
          this.branchList.push(data);
        });
        // sorting
        const sorted = this.filteredBranch.sort((a, b) => (a.bl_fi_mst_branch.code < b.bl_fi_mst_branch.code ? -1 : 1));
        this.filteredBranch = sorted;
        this.filteredOptions$.next(this.filteredBranch.slice());
      });
    }
  }

  filterBranch() {
    if (!this.filteredBranch) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredBranch.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the locations
    this.filteredOptions$.next(
      this.filteredBranch.filter((option) =>
        (option.bl_fi_mst_branch.code ?
          option.bl_fi_mst_branch.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.bl_fi_mst_branch.name ?
          option.bl_fi_mst_branch.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  // searchBranch(searchText: string) {
  //   const query = `
  //     SELECT hdr.guid as requiredGuid
  //     FROM bl_fi_mst_branch AS hdr
  //     WHERE
  //     hdr.status != 'DELETED'
  //     AND (
  //     hdr.code ILIKE'%${searchText}%'
  //     OR hdr.name ILIKE '%${searchText}%'
  //     )
  //     GROUP BY hdr.guid
  //     ORDER BY hdr.name, hdr.guid
  //   `;
  //   return this.subQueryService.post({ 'subquery': query, 'table': 'bl_fi_mst_branch' }, this.apiVisa).pipe(
  //     mergeMap( b => {
  //       const source: Observable<BranchContainerModel>[] = [];
  //       b.data.forEach( guid => source.push(this.branchService.getByCriteria(new Pagination(null, null, [
  //           {columnName: 'hdr_guids', operator: '=', value: guid.toString()}
  //         ]), this.apiVisa).pipe(
  //           map(b_inner => b_inner.data[0])
  //         )
  //       ));
  //       return iif(() => b.data.length > 0,
  //       forkJoin(source).pipe(),
  //       of([])
  //       );
  //     })
  //   );
  // }

  onSelect(branchGuid: string) {
    if (branchGuid) {
      this.branch.patchValue(branchGuid);
      this.selectedBranch = this.branchList.find(branch => branch.bl_fi_mst_branch.guid === branchGuid);
      this.branchSelected.emit(this.selectedBranch);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
